import React, { useState } from 'react';
import { Table } from 'antd';
import { getTableColumns, getTableDataSource } from '../utils/table';
import NPSDetailsModal from './NPSDetailsModal';

const NPSTable = ({ data, isLoading }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const handleViewDetails = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
  };

  const columns = getTableColumns(handleViewDetails);
  const dataSource = getTableDataSource(data);

  return (
    <>
      <Table
        columns={columns}
        dataSource={dataSource}
        loading={isLoading}
        pagination={{
          pageSize: 20,
          showSizeChanger: true,
          showTotal: (total) => `Всего: ${total} оценок`,
          pageSizeOptions: ['10', '20', '50', '100'],
        }}
        rowKey="key"
        size="middle"
        scroll={{ x: 800 }}
        onRow={(record) => ({
          onClick: () => handleViewDetails(record),
          style: { cursor: 'pointer' },
        })}
      />
      <NPSDetailsModal
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        record={selectedRecord}
      />
    </>
  );
};

export default NPSTable;
